<template>
  <v-container v-if="personal">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-col>
          <v-col cols="8">
            <personal-info-card-component :personal="personal"></personal-info-card-component>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn text color="secondary" @click="abrirRegistrarAsistencia">
          <v-icon left>mdi-plus</v-icon>
          Registrar asistencia
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <listado-asistencias-modal ref="listado" :selected-personal="personal" hide-personal-info />
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else-if="errorCarga" fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <v-icon size="64" color="error">mdi-alert-circle-outline</v-icon>
        <p class="mt-4 text--secondary">No se pudo cargar la información del personal.</p>
        <v-btn text @click="$router.go(-1)">Volver</v-btn>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="secondary" size="64" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import PersonalInfoCardComponent from '@/components/PersonalInfoCardComponent.vue'
import ListadoAsistenciasModal from '@/components/enlace_nuevo/dialog-content/ListadoAsistenciasModal.vue'

export default {
  name: 'AsistenciasPersonalRH',

  components: { PersonalInfoCardComponent, ListadoAsistenciasModal },

  props: {
    id: { type: Number, required: true },
  },

  data() {
    return { personal: null, errorCarga: false }
  },

  computed: {
    ...mapGetters('personal', { personalSingle: 'getPersonalSingle' }),
  },

  async mounted() {
    try {
      await this.fetchPersonalById(this.id)
      this.personal = this.personalSingle
    } catch {
      this.errorCarga = true
    }
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    abrirRegistrarAsistencia() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.REGISTRAR_ASISTENCIA,
        props: { selectedPersonal: this.personal, allowDateSelection: true },
        listeners: {
          close: async () => {
            await this.$store.dispatch('asistencia/fetchAsistencias', this.id)
            this.$store.commit('dialog/CLOSE_DIALOG')
          },
        },
      })
    },
  },
}
</script>
